export enum EOrderTime {
  ASAP = 'asap',
  CUSTOM_TIME = 'custom_time',
}
